// import { Message } from 'element-ui';
// import Cookies from 'js-cookie';
// 环境的切换
// if (import.meta.env.MODE === 'development') {
//     axios.defaults.baseURL = '';
// } else if (import.meta.env.MODE === 'production') {
//     axios.defaults.baseURL = '';
// }

import axios from 'axios';
import { ResponseStatus } from '@/request/apiConfig';
import { ElMessage } from 'element-plus';
import router from '@/router';
import { RouteName } from '@/router/RouteName';
import { useUser } from '@/store/pinia/userStore';

function errorInfo(msg: string) {
  console.error('请求失败', msg);
  ElMessage.error(msg);
  // message.error(msg);
  // _this.$message.warning(msg);
  // Message.error(msg);
  // fx.log(msg);
}

export const CONTENT_PATH = '/';
// 超时时间
// axios.defaults.timeout = 10000;

const instance = axios.create({
  timeout: 1000 * 60,
});

// 请求头
// axios.defaults.headers =
// {"Access-Control-Allow-Origin":"","common":{ "Content-Type":"application/json; charset=utf-8"}}
// instance.defaults.headers.common['Content-Type'] = 'application/json; charset=utf-8';
// instance.defaults.headers['Access-Control-Allow-Origin'] = '*';
// axios.defaults.headers.common['Access-Control-Allow-Methods'] = "GET, POST, OPTIONS";
// axios.defaults.headers.common['Access-Control-Allow-Headers'] =
// "DNT,X-CustomHeader,Keep-Alive,User-Agent,
// X-Requested-With,If-Modified-Since,Cache-Control,Content-Type";
// axios.defaults.headers.common['Access-Control-Max-Age'] = "1728000";
// axios.defaults.headers.common['Access-Control-Allow-Credentials'] = true;
instance.defaults.withCredentials = true;

instance.defaults.baseURL = CONTENT_PATH;
// 添加请求拦截器
// instance.interceptors.request.use(
//   (config) => {
//     // Message.info("发起请求 " + document.cookie);
//     fx.log(`发起请求 ${document.cookie}`);
//     fx.log(JSON.stringify(config));
//     try {
//       const token = fx.getToken();
//       if (token != null) {
//         Cookies.set('JSESSIONID', token);
//       } else {
//         Cookies.set('JSESSIONID', Cookies.get('JSESSIONID'));
//       }
//       //  else {
//       // Cookies.set("JSESSIONID", "20E74122A5BEEDB24603711766B45E82");
//       // }
//       fx.log(`浏览器中的cookie ${document.cookie}`);
//     } catch (error) {
//       fx.log(error.message);
//     }
//     return config;
//   },
//   (error) =>
//     // 对请求错误做些什么
//     Promise.reject(error)
//   ,
// );

// 添加响应拦截器
instance.interceptors.response.use(
  (response) => {
    // 对响应数据做点什么
    if (response && response.status === 200 && response.data) {
      if (response.data.status === ResponseStatus.SUCCESS) {
        return Promise.resolve(response.data);
      }
      errorInfo(response.data.msg);
    }
    if (response.data.errcode === ResponseStatus.UNAUTHORIZED) {
      router.replace({
        name: RouteName.LOGIN,
      });
    }
    if (response?.data?.errcode === ResponseStatus.NO_MSGAUDIT_CONFIG) {
      const user = useUser();
      if (user.checkPermission('route-parameter')) {
        router.replace({
          name: RouteName.SETTING_PARAMETER,
        });
      }
    }
    return Promise.reject(response);

    // return response;
  },
  (error): Promise<any> => {
    // 对响应错误做点什么
    if (!error.response.status) {
      return Promise.resolve();
    }
    switch (error.response.status) {
      case 404:
        errorInfo('接口不存在');
        break;
      case 500:
        errorInfo('接口异常');
        break;
      case 502:
        // errorInfo()
        break;
      default:
    }
    return Promise.reject(error);
  },
);
export default instance;
